export function getSiteName(address) {
    const addresses = joinAddressComponents({
        components: [address.address1, address.address2],
        separator: ' ',
    });
    let result = joinAddressComponents({
        components: [address.city, addresses],
        separator: ' - ',
    });
    if (address.businessName) {
        result = `${result} (${address.businessName})`;
    }
    return result;
}
function joinAddressComponents(input) {
    return input.components
        .map((x) => x?.trim?.())
        .filter(Boolean)
        .join(input.separator);
}
